
class VoicemailPlayer {
    [x: string]: any;
 	 static $inject = ['BASE_URL'];
    constructor(BASE_URL) {
        this.BASE_URL = BASE_URL;
    }

    $onInit() {
      this.voicemailUrl = this.BASE_URL + this.url;
    }
}

export const FileDropPlayer =  {
    controller: VoicemailPlayer,
    template : require('./file-drop-player.html'),
    bindings: {url: '<', refresh: "&", voiceMailFileName: '@', voiceMailDropEnabled: '<', remove: '&'}
};
